import { Modal } from "antd";

import "./loyaltyModal.scss";

function LoyaltyModal({
  visible,
  onCancel,
  title,
  footer,
  children,
  width = 550,
  className = "",
  closable = true,
  destroyOnClose,
  bodyStyle,
  centered = true,
}) {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={title}
      footer={footer}
      centered={centered}
      closable={closable}
      width={width}
      destroyOnClose={destroyOnClose}
      bodyStyle={bodyStyle}
      className={`loyalty-modal ${className}`.trim()}
    >
      {children}
    </Modal>
  );
}

export default LoyaltyModal;
